/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
// import Bugsnag from '@bugsnag/js';
import BugsnagVue from '@bugsnag/plugin-vue';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import '@fortawesome/fontawesome-free/css/all.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import moment from 'moment';
import bugsnagClient from './lib/bugsnag';

import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/vuetify';

Vue.config.productionTip = false;

// Instantiate our Bugsnag client
// appVersion is used to track bugs through the panel
// bugsnagClient.use(BugsnagVue(Vue));

// Bind the Bugsnag client to the global Vue instance
bugsnagClient.use(BugsnagVue, Vue);

Vue.filter('formatDate', (value) => {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm');
  }
});

Vue.use(VueAxios, axios);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
